import React from 'react';
import { Card, PageTitle } from '../../../styles';
import Table from '../../../components/Table/Table';
import {
  getPreviousUploadsListAction,
} from '../../../actions/radminUploads';
import Box from '../../../components/_styles/Box';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { EmptyState } from '../../../components/EmptyState/EmptyState';
import { ReactComponent as EmptyStateImg } from '../../../assets/empty-state-search.svg';
import LoadMoreButton from '../../../components/LoadMoreButton';
import { useState } from 'react';
import { useEffect } from 'react';

const DownloadFileLink = styled.a`
  padding: 10px;
  background: #00AEEF;
  color: white;
  border-radius: 5px;
  text-align: center;
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`
const downloadClickAnalytic = () => {
  window.analytics.track('Previous-Uploads-Download-Click');
}
const columns = [
  { key: 'id', name: 'File ID' },
  { key: 'status', name: 'Status'},
  { key: 'error', name: 'Error'},
  { key: 'upload_file', name: 'Link To Download', displayCell: (cellValue) => <DownloadFileLink href={cellValue} download onClick={downloadClickAnalytic}>Download</DownloadFileLink> },
];

const PreviousUploadsList = () => {
    const dispatch = useDispatch();
  
  const previousUploads = useSelector(state => state.radAdmin.previousUploads);
  const [page, setPage] = useState(1);

    useEffect(() => {
   

          dispatch(getPreviousUploadsListAction(page));

    }, []);

  const onLoadMore = () => {
     
      dispatch(getPreviousUploadsListAction(page + 1));
      
      setPage(page + 1);
    };
  return (
    <Box p={30}>
      <PageTitle>Previous Uploads</PageTitle>
      <Card>
        <Table
          rows={previousUploads.data}
          columns={columns}
          initialPageNumber={previousUploads.pageNumber}
          totalItems={previousUploads.totalItems}
          isLoadingRows={previousUploads?.isLoading && page < 2}
          shouldGetRowActions={false}
          noDataRender={() => <EmptyState title={'No Results'} img={() => <EmptyStateImg />} buttonInfo={{link: '/auth/radAdmin/Import', text: 'Import Data'}}>Sorry, there are no results</EmptyState>}
        />
        {previousUploads?.data &&
                        previousUploads?.data.length !== 0 && (
                          <LoadMoreButton
                            title="Load more"
                            handleClick={onLoadMore}
                            isDisabled={
                              previousUploads?.totalItems ===
                              previousUploads?.data?.length
                            }
                            isLoading={previousUploads?.isLoading && page >= 2}
                            style={{
                              backgroundColor: "#0c2945",
                              fontWeight: 600,
                            }}
                          />
                        )}
      </Card>
    </Box>
  )
};

export default PreviousUploadsList;
